// apps/web/src/components/bank/BankCard.tsx
// 题库卡片组件 — 展示单个题库信息

import { Link } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import { zhCN } from "date-fns/locale";
import type { BankDTO } from "@examfast/shared-types";
import { normalizeEpochMs } from "@utils/time";

interface BankCardProps {
  bank: BankDTO;
  selectionMode?: boolean;
  selected?: boolean;
  onToggle?: () => void;
}

export default function BankCard({ bank, selectionMode = false, selected = false, onToggle }: BankCardProps) {
  const lastStudied = bank.last_studied_at
    ? formatDistanceToNow(normalizeEpochMs(bank.last_studied_at), { addSuffix: true, locale: zhCN })
    : "从未学习";

  return (
    <div className={`relative bg-white rounded-xl shadow-card ${selected ? "ring-2 ring-primary" : ""}`}>
      {selectionMode && (
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggle}
          aria-label={`选择${bank.name}`}
          className="absolute right-3 top-3 z-10 h-5 w-5 accent-primary"
        />
      )}
      <Link
        to={selectionMode ? "#" : `/banks/${bank.id}`}
        onClick={selectionMode ? (event) => { event.preventDefault(); onToggle?.(); } : undefined}
        className="block p-4 hover:shadow-card-hover transition-shadow duration-200 btn-tap"
      >
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-base font-bold text-gray-900 truncate">{bank.name}</h3>
          {bank.tag && (
            <span className="shrink-0 inline-block text-xs px-2 py-0.5 rounded-full
                             bg-primary/10 text-primary font-medium">
              {bank.tag}
            </span>
          )}
        </div>
        <div className="mt-2 flex items-center gap-3 text-xs text-gray-500">
          <span>{bank.question_count} 题</span>
          <span className="text-gray-300">|</span>
          <span>{lastStudied}</span>
        </div>
      </Link>
    </div>
  );
}
